import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { cmsAPI } from "../../services/api";

export function Seo({ page, defaultTitle = "Sava Fresh Trading FZE", defaultDesc = "Premium global food trading company.", defaultKeywords = "food trading, global sourcing, export", fallbackObj = null }) {
  const [seo, setSeo] = useState({ title: "", description: "", keywords: "" });

  useEffect(() => {
    if (fallbackObj) {
      setSeo({
        title: fallbackObj.metaTitle || fallbackObj.name || fallbackObj.title || defaultTitle,
        description: fallbackObj.metaDesc || fallbackObj.shortDesc || fallbackObj.excerpt || defaultDesc,
        keywords: fallbackObj.metaKeywords || defaultKeywords,
      });
      return;
    }

    if (!page) return;

    cmsAPI.getPage(page)
      .then(r => {
        const content = r.data.content || {};
        const seoData = content.seo || {};
        setSeo({
          title: seoData.title?.value || defaultTitle,
          description: seoData.description?.value || defaultDesc,
          keywords: seoData.keywords?.value || defaultKeywords,
        });
      })
      .catch(() => {
        setSeo({ title: defaultTitle, description: defaultDesc, keywords: defaultKeywords });
      });
  }, [page, fallbackObj, defaultTitle, defaultDesc, defaultKeywords]);

  return (
    <Helmet>
      {seo.title && <title>{seo.title}</title>}
      {seo.description && <meta name="description" content={seo.description} />}
      {seo.keywords && <meta name="keywords" content={seo.keywords} />}
    </Helmet>
  );
}

export default Seo;
